import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useDispatch } from 'react-redux';
import { ProfileTypes } from '@api/Users/User';
import { getProfileName } from '@utils/Profiles';
import { setProfileSelected } from '@store/authStore';
import { PREVIEW_BANNER_HEIGHT, useProfilePreview } from '@hooks/useProfilePreview';

// ============================================================================
// Aviso de "Ver como" (2026-08-18).
//
// Existe porque previsualizar NO es inocuo: `hasPermission` lee
// `profileSelected`, así que mientras el admin mira el sistema como gerente o
// colaborador, opera CON LOS PERMISOS DE ESE PERFIL — le desaparecen botones
// (eliminar pedido, puntos manuales, edición de órdenes) sin explicación.
// Antes eso pasaba en silencio y era imposible de notar. Ahora hay una barra
// fija con salida en un clic.
// ============================================================================

const PreviewModeBanner: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const { isPreviewing, previewProfile } = useProfilePreview();

    if (!isPreviewing) {
        return null;
    }

    return (
        <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="center"
            sx={{
                height: PREVIEW_BANNER_HEIGHT,
                bgcolor: 'warning.main',
                color: 'warning.contrastText',
                px: 2
            }}
        >
            <VisibilityIcon fontSize="small" />
            <Typography variant="body2" fontWeight={600} noWrap>
                Estás viendo el sistema como {getProfileName(previewProfile)} — con sus permisos, no los tuyos
            </Typography>
            <Button
                size="small"
                variant="outlined"
                color="inherit"
                onClick={() => dispatch(setProfileSelected(ProfileTypes.Admin))}
                sx={{
                    // Compacto: la barra mide PREVIEW_BANNER_HEIGHT y un botón
                    // sólido de alto normal se sale y se come el aviso
                    height: 24,
                    py: 0,
                    px: 1.5,
                    fontSize: '0.72rem',
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                    borderColor: 'currentColor',
                    '&:hover': { borderColor: 'currentColor', bgcolor: 'rgba(255,255,255,0.18)' }
                }}
            >
                Volver a mi vista
            </Button>
        </Stack>
    );
};

export default PreviewModeBanner;
